import { useDialogContext } from '../../../contexts/DialogContext';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';
import type { MalwareReport } from '../../../../shared/model-typings/malwarereport';

function deleteMalwareReport(id: number): Promise<Response> {
  return remove(`/api/internal-tools/malware/${id}`);
}

/**
 * Hook to delete a malware report with confirmation dialog
 */
export default function useDeleteMalwareReport() {
  const { onConfirm } = useDialogContext();

  const mutation = useToastedMutation({
    mutationFn: deleteMalwareReport,
    successToastMessage: 'Malware report has been successfully deleted.',
    errorToastMessage: 'An error occurred while deleting the malware report. Please try again.',
    onSuccess: () => {
      // Invalidate and refetch malware reports
      queryClient.invalidateQueries({ queryKey: ['malware'] });
    },
  });

  const onDeleteMalwareReport = (malwareReport: MalwareReport) => {
    onConfirm({
      title: 'Confirm malware report deletion',
      body: `Are you sure you want to delete the malware report "${malwareReport.name}"?`,
      onConfirm: async () => {
        mutation.mutate(malwareReport.id);
      },
    });
  };

  return {
    onDeleteMalwareReport,
    isDeleting: mutation.isPending,
  };
}
